import React from 'react';
import { NavLink as Link } from 'react-router-dom';

const Sidebar = ({ isNavActive, showSavedCards, dataLocale, localeInfo, redisCommonData }) => {
  const isActiveLink = () => isNavActive;
  const {
    MY_ORDERS,
    ACCOUNT_INFORMATION,
    MY_DITTO,
    MY_3D,
    ADDRESS_BOOK,
    STORE_CREDIT,
    CHECK_VOUCHER_BALANCE,
    MY_PRESCRIPTIONS,
    SAVED_CARDS,
    MANAGE_NOTIFICATIONS,
  } = dataLocale;
  return (
    <ul className="my-ac-list">
      <li>
        {' '}
        <Link isActive={isActiveLink} to="/customer/account/">
          {MY_ORDERS}
        </Link>
      </li>
      {redisCommonData?.ENABLE_CYGNUS && redisCommonData.SHOW_DELETE_DITTO && (
        <li className="ditto-nav-item">
          <Link exact activeClassName="active" to="/customer/3D-profile">
            {MY_3D}
          </Link>
        </li>
      )}
      <li>
        <Link exact activeClassName="active" to="/customer/account/edit/">
          {ACCOUNT_INFORMATION}
        </Link>
      </li>
      {localeInfo.countryCode !== 'sg' && (
        <li>
          <Link activeClassName="active" to="/customer/manage-notification">
            {MANAGE_NOTIFICATIONS}
          </Link>
        </li>
      )}
      <li className="">
        {' '}
        <Link activeClassName="active" to="/customer/address/">
          {ADDRESS_BOOK}
        </Link>
      </li>
      <li>
        {' '}
        <Link exact activeClassName="active" to="/customer/prescriptions/">
          {MY_PRESCRIPTIONS}
        </Link>
      </li>
      {showSavedCards && (
        <li>
          {' '}
          <Link exact activeClassName="active" to="/customer/saved-cards/">
            {SAVED_CARDS}
          </Link>
        </li>
      )}
      <li>
        <Link exact activeClassName="active" to="/customer/giftvoucher/balance-check/">
          {CHECK_VOUCHER_BALANCE}
        </Link>
      </li>
      {localeInfo.countryCode === 'in' && (
        <li>
          <Link exact activeClassName="active" to="/customer/account/storecredit/">
            {STORE_CREDIT}
          </Link>
        </li>
      )}
      {!redisCommonData?.ENABLE_CYGNUS && (
        <li className="ditto-nav-item">
          <Link exact activeClassName="active" to="/customer/ditto-profile/">
            {MY_DITTO}
          </Link>
        </li>
      )}
    </ul>
  );
};

export default Sidebar;
